import { createContext, useContext } from 'react';
import { HintContextValue } from './hint.types';

export const HintContext = createContext<HintContextValue | null>(null);

export const useHint = () => {
  const ctx = useContext(HintContext);

  if (!ctx) {
    throw new Error('Hint компонент должен быть внутри <Hint.Root>');
  }

  return ctx;
};
